import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="site-footer">
      <div className="site-footer__grid">
        <div>
          <h4>{t('footer.heading')}</h4>
          <p className="paragraph-footer">
            {t('footer.address.line1')} <br />
            {t('footer.address.line2')} <br />
            {t('footer.address.line3')}
          </p>
        </div>

        <div>
          <h5>{t('footer.useful_links')}</h5>
          <ul>
            <li>
              <a href="/about">{t('footer.about')}</a>
            </li>
            <li>
              <a href="/privacy">{t('footer.privacy')}</a>
            </li>
            <li>
              <a href="/faq">{t('footer.faq')}</a>
            </li>
          </ul>
        </div>

        <div>
          <h4>{t('footer.contact')}</h4>
          <p>
            {t('footer.phone')}: 055 283 0083
          </p>
          <p>
            {t('footer.email')}:{' '}
            <a href="mailto:info@wassiniluxury.com">info@wassiniluxury.com</a>
          </p>
          <div className="site-footer__social">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>

      <hr className="site-footer__divider" />
      <p className="site-footer__copyright">
        © {new Date().getFullYear()} <strong>WASSINI LUXURY</strong>.{' '}
        {t('footer.rights')}
      </p>
    </footer>
  );
};

export default Footer;
